// extracted by mini-css-extract-plugin
module.exports = {"activeTab":"FarmbookHeader_activeTab__vsuzr","tab":"FarmbookHeader_tab__3eg7K"};